import { createOrphanRefusal } from "@/components/shipments/confirm-address-refusal"

/**
 * OKS-1040 (PO re-walk R1, frames p4-06a/b/c) — a MARK-SHIPPED refusal whose
 * dialog is gone.
 *
 * The race: the brand adds a 2nd product while a Ready parcel's ship dialog
 * sits open. The server correctly refuses (`product_choice_required`, nothing
 * written, 302 + `errors.base`) — but the reloaded props move the row
 * Ready → Waiting (the choice is now outstanding), so the parcel's `<li>`
 * unmounts, `MarkShippedDialog` with it, and the base Alert had nowhere to
 * render. Same shape as OKS-1037 D1; this is its second instance, on its own
 * context so the two doors' refusals never mix.
 *
 *   dialog still open  → the dialog's OKS-1006 base Alert shows it
 *   dialog unmounted   → the page shows it, once, above the queue
 */
// inertia-i18n-use shipments.product_choice.close
const ship = createOrphanRefusal({
  testIdPrefix: "shipments-ship",
  closeKey: "shipments.product_choice.close",
})

export const ShipRefusalProvider = ship.Provider
export const useShipRefusal = ship.useRefusal
